import React from "react";
import {
    Grid,
    Typography,
    Button,
    Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { CheckCircleOutline } from "@mui/icons-material";

const StyledButton = styled(Button)(() => ({
    padding: '12px',
    borderRadius: '8px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
    },
}));

interface OwnProps {
    doneClickHandler: () => void
}

const ResetPasswordSuccess = (props: OwnProps) => {

    return (
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
            <Box sx={{ 
                backgroundColor: theme => theme.palette.success.light,
                borderRadius: '50%',
                width: 80,
                height: 80,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 3
            }}>
                <CheckCircleOutline sx={{ 
                    color: theme => theme.palette.success.dark, 
                    fontSize: 40 
                }} />
            </Box>
            
            <Typography 
                variant="h5" 
                fontWeight="600" 
                color="primary" 
                align="center" 
                gutterBottom 
                data-cy="resetRequestSuccessHeader"
            >
                Password Reset Successful!
            </Typography>

            <Box sx={{ 
                backgroundColor: theme => theme.palette.grey[50],
                borderRadius: '8px',
                p: 3,
                mb: 4,
                maxWidth: '400px',
                border: theme => `1px solid ${theme.palette.grey[200]}`
            }}>
                <Typography 
                    align="center" 
                    variant="body1"
                >
                    Your login details have been successfully updated. You can now use your new password to access your account.
                </Typography>
            </Box>
            
            <StyledButton 
                variant="contained" 
                onClick={props.doneClickHandler} 
                data-cy="homepageButton"
                fullWidth
                size="large"
                sx={{ maxWidth: '400px' }}
            >
                Continue to Home Page
            </StyledButton>
        </Grid>
    )
}

export default ResetPasswordSuccess;
